import { withInRange } from '../../common/utils/helper';
import { ColumnBase } from './column-base';
/**
 * The `HiloSeries` module is used to render the hilo series.
 */
export class HiloSeries extends ColumnBase {
    constructor() {
        super(...arguments);
        this.sideBySideInfo = [];
    }
    /**
     * Render Hiloseries.
     *
     * @returns {void}
     * @private
     */
    render(series) {
        this.sideBySideInfo[series.index] = this.getSideBySideInfo(series);
        for (const point of series.points) {
            this.renderPoint(series, point, this.sideBySideInfo[series.index]);
        }
    }
    renderPoint(series, point, sideBySideInfo) {
        point.symbolLocations = [];
        point.regions = [];
        let region;
        if (point.visible &&
            withInRange(series.points[point.index - 1], point, series.points[point.index + 1], series)) {
            region = this.getRectangle(point.xValue + sideBySideInfo.median, point.high, point.xValue + sideBySideInfo.median, point.low, series);
            const argsData = this.triggerPointRenderEvent(series, point);
            if (!argsData.cancel) {
                if (!series.chart.requireInvertedAxis) {
                    region.width = argsData.border.width;
                    region.x = region.x - (region.width / 2);
                }
                else {
                    region.height = argsData.border.width;
                    region.y = region.y - (region.height / 2);
                }
                argsData.border.width = 0;
                this.updateSymbolLocation(point, region, series);
                this.drawRectangle(series, point, region, argsData);
            }
        }
    }
    updateDirection(series, point) {
        for (let i = 0; i < point.length; i++) {
            this.renderPoint(series, series.points[point[i]], this.sideBySideInfo[series.index]);
            if (series.marker.dataLabel.visible && series.chart.dataLabelModule) {
                series.chart.dataLabelModule.commonId = series.chart.element.id + '_Series_' + series.index + '_Point_';
                series.chart.dataLabelModule.renderDataLabel(series, series.points[point[i]], null, series.marker.dataLabel);
            }
        }
    }
    /**
     * Triggers the point render event for the specified series and data point.
     *
     * @param {Series} series - The series associated with the point.
     * @param {Points} point - The data point.
     * @returns {IPointRenderEventArgs} The event arguments.
     */
    triggerPointRenderEvent(series, point) {
        const border = { color: series.fill, width: Math.max(series.border.width, 2) };
        return super.triggerEvent(series, point, series.interior, border);
    }
    /**
     * Get module name.
     *
     * @returns {string} - Returns the module name.
     */
    getModuleName() {
        return 'HiloSeries';
        /**
         * return the module name.
         */
    }
    /**
     * Animates the series.
     *
     * @param  {Series} series - Defines the series to animate.
     * @returns {void}
     * @private
     */
    doAnimation(series) {
        this.animate(series);
    }
    /**
     * To destroy the Hilo series.
     *
     * @returns {void}
     * @private
     */
    destroy() {
        /**
         * Destroys the Hilo Series.
         */
    }
}
